import React from "react"
import {useAccessToken} from "../../../../services/auth"
import useAsyncResultIdle from "../../../../hooks/useAsyncResultIdle"

import {Application, resubmitBusinessApplication} from "../../../../resources/application"
import {ErrorDocument} from "../../../../resources/common"
import ConfirmationModalContent from "../ConfirmationModalContent"
import {
	ReevaluatedBusinessApplicationData,
	ReevaluatedBusinessApplicationDataRequest,
} from "../../Forms/ReevaluateBusinessForm/ReevaluateBusinessForm"

export default function ReevaluateBusinessApplicationConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	onError: (error?: ErrorDocument) => void
	application: Application
	enableReevaluateApplication: boolean
	reevaluatedData: ReevaluatedBusinessApplicationData
}) {
	const {close, onSuccess, onError, application, enableReevaluateApplication, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateBusinessRequest, setUpdateBusinessRequest] = useAsyncResultIdle(resubmitBusinessApplication)

	const handleSubmit = (reason: string) => {
		const data = {
			phone: reevaluatedData.phone,
			address: reevaluatedData.address,
			operatingAddress: reevaluatedData.operatingAddress,
			ein: reevaluatedData.ein,
			website: reevaluatedData.hasNoWebsite ? null : reevaluatedData.website,
			dba: reevaluatedData.dba,
			name: reevaluatedData.name,
			businessVertical: reevaluatedData.businessVertical,
			yearOfIncorporation: reevaluatedData.yearOfIncorporation,
			numberOfEmployees: reevaluatedData.numberOfEmployees,
			annualRevenue: reevaluatedData.annualRevenue,
			stockSymbol: reevaluatedData.stockSymbol,
			cashFlow: reevaluatedData.cashFlow,
			businessIndustry: reevaluatedData.businessIndustry,
			sourceOfFunds: reevaluatedData.sourceOfFunds,
			sourceOfFundsDescription: reevaluatedData.sourceOfFundsDescription,
			accountPurpose: reevaluatedData.accountPurpose,
			accountPurposeDetail: reevaluatedData.accountPurposeDetail,
			stockExchangeName: reevaluatedData.stockExchangeName,
			transactionVolume: reevaluatedData.transactionVolume,
			transactionVolumeDescription: reevaluatedData.transactionVolumeDescription,
			isRegulated: reevaluatedData.isRegulated,
			regulatorName: reevaluatedData.regulatorName,
			usNexus: reevaluatedData.usNexus,
			countriesOfOperation: reevaluatedData.countriesOfOperation,
			businessDescription: reevaluatedData.businessDescription,
		} as ReevaluatedBusinessApplicationDataRequest

		setUpdateBusinessRequest(accessToken, application, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateBusinessRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			onError={onError}
			enableReevaluateApplication={enableReevaluateApplication}
		/>
	)
}
